export function requiredValid(value) {
	return (value !== null && value !== undefined && value.toString().length > 0);
}

export function greaterThanValid(minValue, value) {
	return requiredValid(value) && !isNaN(value) && value > minValue;
}

export function floatValid(value) {
	return !isNaN(value);
	// return /^[0-9]{1,9}([.,][0-9]{1,3})?$/.test(value);
}

export function selectRequiredValid(value) {
	return requiredValid(value);
}